export default __webpack_public_path__ + "static/media/vle.39e55df1.png";